import React from 'react';

import ProjectMaterialForm from './ProjectMaterialForm';

const ProjectIssue = () => {
  return <ProjectMaterialForm mode="issue" />;
};

export default ProjectIssue;
